import React from "react"
import { Outlet } from "react-router-dom"
import Header from "../components/globals/Header"
import Toaster from "../components/globals/Toaster"
import { ModalRootElement } from "../components/elements/Modal"

// tailwind css
import '../index.css'

const AnonymousLayout: React.FC = (): React.ReactElement => {
  return (
    <div className="ui-panel-view flex h-full w-full flex-col overflow-hidden">
      <Header />
      <div className="ui-layout-wrapper block min-h-0 w-full flex-1 overflow-y-auto overflow-x-hidden px-[28px]"><Outlet /></div>
      <Toaster />
      <ModalRootElement />
    </div>
  )
}

export default AnonymousLayout
